import moment from "moment";
const AppPlugin = {}

AppPlugin.install = function (Vue, options) {
	Vue.prototype.hasPermission = function hasPermission (parametros) {
		let permissoes = [];
		permissoes = permissoes.concat(parametros)
		let teste = false;
		let self = this;
		permissoes.forEach(function (element) {
			teste = teste || (self.$acl.get.indexOf(element) > -1);
		});
		return teste;
	}

	Vue.prototype.setUsuarioAtual = function setUsuarioAtual (userCurrent) {
		this.$store.commit('SET_USER', userCurrent) // Setando o usuário corrente no estado do vuex (store)
		if (window.localStorage) {
			window.localStorage.setItem('user', JSON.stringify(userCurrent))
		}
		this.$acl.change(['public', ...userCurrent.permissoes]);
	}

	Vue.prototype.logout = function logout () {
		this.$store.commit('SET_USER', null)
		this.$store.commit('SET_TOKEN', null)

		if (window.localStorage) {
			window.localStorage.removeItem('user')
			window.localStorage.removeItem('token')
		}

		this.$router.push('/login')
	}

	Vue.prototype.nivelNumber = function nivelNumber (nivel) {
		let niveis = ['usuario', 'gerente', 'administrador']; // niveis em ordem hierárquica do menor para o maior
		return niveis.indexOf(nivel);
	}

	Vue.prototype.nivelCompare = function nivelCompare (nivel1, operador, nivel2) {
		var foo = window;

		nivel1 = this.nivelNumber(nivel1);
		nivel2 = this.nivelNumber(nivel2);
		let operadores = ['==', '!=', '>=', '<=', '>', '<'];
		let aux = null;
		if (operadores.indexOf(operador) > -1) {
			aux = foo.eval(nivel1 + ' ' + operador + ' ' + nivel2)
		}
		return aux;
	}

	Vue.prototype.formatDates = function formatDates (dateOne, dateTwo, ope) {
		let formattedDates = ''
		if (dateOne) {
			formattedDates = moment(dateOne).format("DD/MM/YYYY")
		}
		if (dateTwo && ope == '><') {
			formattedDates += ' a ' + moment(dateTwo).format("DD/MM/YYYY")
		}
		return formattedDates
	}

	Vue.prototype.mergeRecursivo = function mergeRecursivo (target, ...sources) {
		if (!sources.length) return target;
			const source = sources.shift();

		if (this.isObject(target) && this.isObject(source)) {
			for (const key in source) {
			if (this.isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				this.mergeRecursivo(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
			}
		}

		return this.mergeRecursivo(target, ...sources);
	}

	Vue.prototype.isObject = function isObject (item) {
		return (item && typeof item === 'object' && !Array.isArray(item));
	}
}

export default AppPlugin;



// WEBPACK FOOTER //
// ./src/plugins/AppPlugin.js